import { ReferenceField, FunctionField, useRecordContext, Labeled } from 'react-admin';
import { Typography } from '@mui/material';
import { EventType, Event } from '../../types';

const PrintStopCauseContent = ({ eventType, record }: { record?: Event; eventType: EventType }) => {
  if (!record?.rawContent) return null;
  if (eventType.name !== 'print-stop') return null;

  try {
    const rawData = JSON.parse(record.rawContent);
    const cause = rawData?.fields?.cause;

    if (!cause) return null;

    return (
      <Labeled label="Stop Cause">
        <Typography variant="body1" sx={{ color: 'warning.main', fontWeight: 500 }}>
          {cause}
        </Typography>
      </Labeled>
    );
  } catch {
    // Error parsing rawContent, silently ignore
    return null;
  }
};

export const PrintStopCause = () => {
  const record = useRecordContext<Event>();
  return (
    <ReferenceField source="eventTypeId" reference="event-types" link={false}>
      <FunctionField
        render={(eventType: EventType) => (
          <PrintStopCauseContent record={record} eventType={eventType} />
        )}
      />
    </ReferenceField>
  );
};
